(function () {
  function tagsOf(card) {
    return (card.getAttribute('data-mb-tags') || '').split(' ').filter(Boolean);
  }

  function initFilters(root) {
    var pills = Array.prototype.slice.call(root.querySelectorAll('[data-mb-filter]'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-mb-tags]'));
    var empty = root.querySelector('[data-mb-empty]');
    if (!pills.length || !cards.length) return;

    pills.forEach(function (pill) {
      var value = pill.getAttribute('data-mb-filter');
      if (value === 'all') return;
      var matches = cards.some(function (card) {
        return tagsOf(card).indexOf(value) !== -1;
      });
      if (!matches) pill.remove();
    });

    var visiblePills = Array.prototype.slice.call(root.querySelectorAll('[data-mb-filter]'));
    if (visiblePills.length <= 1) {
      var bar = root.querySelector('.mb-pills');
      if (bar) bar.remove();
      return;
    }

    visiblePills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var value = pill.getAttribute('data-mb-filter');
        visiblePills.forEach(function (p) { p.classList.remove('is-active'); });
        pill.classList.add('is-active');
        var shown = 0;
        cards.forEach(function (card) {
          var match = value === 'all' || tagsOf(card).indexOf(value) !== -1;
          card.classList.toggle('is-hidden', !match);
          if (match) shown++;
        });
        if (empty) empty.hidden = shown !== 0;
      });
    });
  }

  function initSwatches(root) {
    root.querySelectorAll('[data-mb-swap]').forEach(function (sw) {
      function swap() {
        var card = sw.closest('.mb-card');
        if (!card) return;
        var img = card.querySelector('.mb-media img');
        var src = sw.getAttribute('data-mb-swap');
        if (!img || !src) return;
        img.removeAttribute('srcset');
        img.setAttribute('src', src);
        card.querySelectorAll('.mb-swatch').forEach(function (s) { s.classList.remove('is-active'); });
        sw.classList.add('is-active');
      }
      sw.addEventListener('mouseenter', swap);
      sw.addEventListener('focus', swap);
      sw.addEventListener('touchstart', swap, { passive: true });
    });
  }

  function boot() {
    document.querySelectorAll('[data-mb-collection]').forEach(function (root) {
      initFilters(root);
      initSwatches(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
